import React, {Component} from 'react';
import PropTypes from 'prop-types';
import { Field } from 'redux-form';
import {
  Card,
  CardContent,
  Grid,
  Paper,
} from '@material-ui/core';
import { 
  renderMultiLineTextField,
  renderSelectField6,
} from '../../../form-global-components/components-form-components-for-react-final-form';
import {
  BOP_LEVEL_OF_SECURITY,
} from '../../../../actions/action-constants';
class BOPModuleInstitution extends Component {
  render() {
    return (
      <div>
        <Paper >
          <Card>
            <CardContent>

              <Grid container spacing={3}>  
                <Grid item xs={12} >
                  <Field
                    component={renderSelectField6}
                    id='boplevelofsecurity' 
                    name='boplevelofsecurity'
                    label="BOP Level of Security"
                    locked={this.props.locked}
                    onChange={this.props.changeProgram}
                    autoFocus
                    dataArray={BOP_LEVEL_OF_SECURITY}
                  />
                                                                    {/* footerMessage=''
                                                                                        required
                                                                                        autoFocus
                                                                                      >
                                                                                        <option value='0' >Minimum</option>
                                                                                        <option value='1' >Low</option>
                                                                                        <option value='2' >Medium</option>
                                                                                        <option value='3' >High</option>
                                                                                      </Field> 
                                                                    */}
                </Grid>
              </Grid>

              <Grid container spacing={3}>  
                <Grid item xs={12} >
                  <Field
                    component={renderSelectField6}
                    id='bopinstitution' 
                    name='bopinstitution'
                    label="BOP Institution"
                    locked={this.props.locked}
                    autoFocus
                    dataArray={
                      this.props.bopinstitutionsList.map(bopinstitution => ({
                        value: bopinstitution.id,
                        label: bopinstitution.description
                      }))
                    }
                  />
                                                                {/* 
                                                                                  >
                                                                                    {this.props.bopinstitutionsList.map((bopinstitution, index) => {
                                                                                      return (
                                                                                        <option key={bopinstitution.id} value={bopinstitution.id}>{bopinstitution.description}</option>
                                                                                      )
                                                                                    }) }
                                                                                  </Field> 
                                                                */}
                </Grid>
              </Grid>

              <Grid container spacing={3}>
                <Grid item xs={12} >
                  <Field
                    component={renderMultiLineTextField}
                    locked={this.props.locked}
                    id='bopinstitutioncomments' 
                    name='bopinstitutioncomments'  
                    label="BOP Institution Comments"
                    rows='6'
                    emptyText='Your comments should be clear and concise.'
                    footerMessage='Your comments should be clear and concise.'
                  />
                </Grid>
              </Grid>

            </CardContent>
          </Card>
        </Paper>  
        
      </div>
    );
  }
}
BOPModuleInstitution.propTypes = {
  locked: PropTypes.bool,
  bopinstitutionsList: PropTypes.array,
}
export default BOPModuleInstitution;